export class BrowserService {
    setTitle(title) {
        document.title = title;
    }
    openLink(url) {
        window.open(url);
    }
    close() {
        window.close();
    }
    setLeft(params) {
    }
    getLocation(params) {
        return Promise.reject();
    }
    mapSearch(params) {
        return Promise.reject();
    }
    mapView(params) {
    }
}
